import { UserSessionsForDebugApi } from "../../generated"
import { useQuery } from 'react-query'
import { apiConfig } from "../apiConfig"
import { DebugLoginOption } from "./DebugLoginOption"
import { onError } from "../../professor/stores/user/UserStore"

const api = new UserSessionsForDebugApi(apiConfig)

async function load() {
  return await api.listAcceptor()
}

export function useProfessorList() {
  const { data } = useQuery('useProfessorList', load, { onError })
  const options: DebugLoginOption[] | undefined = data?.map(professor => {
    const d = `${professor.office?.name} ${professor.course?.shortName} ${professor.teacher.name} (${professor.teacher.email})`
    const id = professor.teacher.id?.toString()
    return { value: id ? id : '', label: d }
  })
  return options ? options : []
}
